import * as tslib_1 from "tslib";
import { CrudService } from '@ml/shared/services/crud.service';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var OrderLocationsService = /** @class */ (function (_super) {
    tslib_1.__extends(OrderLocationsService, _super);
    function OrderLocationsService(http) {
        var _this = _super.call(this, http, false) || this;
        _this.http = http;
        _this.removed = new Subject();
        return _this;
    }
    Object.defineProperty(OrderLocationsService.prototype, "url", {
        get: function () {
            return "orders/" + this.orderId + "/locations";
        },
        enumerable: true,
        configurable: true
    });
    OrderLocationsService.prototype.getValues$ = function () {
        return this.values$.asObservable();
    };
    OrderLocationsService.prototype.getValues = function () {
        return this.values$.getValue();
    };
    OrderLocationsService.prototype.subscribe$ = function (orderId) {
        this.orderId = orderId;
        return _super.prototype.list.call(this);
    };
    OrderLocationsService.prototype.updatePositions = function (orderId, positions) {
        var _this = this;
        var url = "orders/" + orderId + "/locations-positions";
        return this.http.patch(url, positions).pipe(tap(function (values) {
            if (_this.orderId === orderId && _this.values$.value) {
                _this.values$.next(values);
            }
        }));
    };
    OrderLocationsService.prototype.bulkCreate = function (orderLocations) {
        var _this = this;
        var url = this.url + "/create";
        return this.http.post(url, orderLocations).pipe(tap(function (values) {
            _this.values$.next(_this.values$.value.concat(values));
        }));
    };
    OrderLocationsService.prototype.bulkRemove = function (orderLocations) {
        var _this = this;
        var url = this.url + "/remove";
        return this.http.post(url, orderLocations).pipe(tap(function () {
            _this.removed.next(orderLocations);
            var values = _this.values$.value
                .filter(function (value) { return orderLocations.indexOf(value.id) < 0; })
                .map(function (value, index) {
                value.position = index;
                return value;
            });
            _this.values$.next(values);
        }));
    };
    OrderLocationsService.prototype.bulkUpdate = function (orderId, locations) {
        var url = "orders/" + orderId + "/locations/update";
        return this.http.post(url, locations);
    };
    OrderLocationsService.prototype.delete = function (valueId) {
        var _this = this;
        var url = this.url + "/" + valueId;
        return this.http.delete(url).pipe(tap(function (values) { return _this.values$.next(values); }), tap(function () { return _this.removed.next([valueId]); }));
    };
    OrderLocationsService.prototype.removed$ = function () {
        return this.removed.asObservable();
    };
    OrderLocationsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function OrderLocationsService_Factory() { return new OrderLocationsService(i0.ɵɵinject(i1.HttpClient)); }, token: OrderLocationsService, providedIn: "root" });
    return OrderLocationsService;
}(CrudService));
export { OrderLocationsService };
